import locale6010b66b from '../../locales/en-US.js'
import localeb12da6aa from '../../locales/zh-HK.js'
import localeb1b7d77a from '../../locales/zh-CN.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"code":"en","iso":"en-US","file":"en-US.js","name":"EN"},{"code":"zh-HK","iso":"zh-HK","file":"zh-HK.js","name":"中"},{"code":"zh-CN","iso":"zh-CN","file":"zh-CN.js","name":"简中"}],
  defaultLocale: "zh-HK",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: false,
  langDir: "~/locales",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":true,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://www.10life.com",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"5star-products/index":{"zh-CN":false},"career/_slug":{"zh-CN":false},"career/index":{"zh-CN":false},"family":{"zh-CN":false},"happy-kids-2024/index":{"zh-CN":false},"happy-kids-2024/cost-of-raising-a-kid-game/index":{"en":false,"zh-CN":false},"happy-kids-2024/cost-of-raising-a-kid-game/test":{"en":false,"zh-CN":false},"products/index":{"zh-CN":false},"products/deferred-annuity/index":{"zh-CN":false},"products/deferred-annuity/longevity/compare":{"zh-CN":false},"products/deferred-annuity/longevity/_slug":{"zh-CN":false},"products/deferred-annuity/retirement/compare":{"zh-CN":false},"products/deferred-annuity/retirement/_slug":{"zh-CN":false},"products/deferred-annuity/savings/compare":{"zh-CN":false},"products/deferred-annuity/savings/_slug":{"zh-CN":false},"products/home/_slug":{"zh-CN":false},"products/home/compare":{"zh-CN":false},"products/home/index":{"zh-CN":false},"products/immediate-annuity/_slug":{"zh-CN":false},"products/immediate-annuity/compare":{"zh-CN":false},"products/immediate-annuity/index":{"zh-CN":false},"products/long-term-savings/_slug":{"zh-CN":false},"products/long-term-savings/compare":{"zh-CN":false},"products/long-term-savings/index":{"zh-CN":false},"products/medical/_slug":{"zh-CN":false},"products/medical/compare":{"zh-CN":false},"products/medical/index":{"zh-CN":false},"products/personal-accident/_slug":{"zh-CN":false},"products/personal-accident/compare":{"zh-CN":false},"products/personal-accident/index":{"zh-CN":false},"products/short-term-savings/_slug":{"zh-CN":false},"products/short-term-savings/compare":{"zh-CN":false},"products/short-term-savings/index":{"zh-CN":false},"products/term-cancer/_slug":{"zh-CN":false},"products/term-cancer/compare":{"zh-CN":false},"products/term-cancer/index":{"zh-CN":false},"products/term-critical-illness/_slug":{"zh-CN":false},"products/term-critical-illness/compare":{"zh-CN":false},"products/term-critical-illness/index":{"zh-CN":false},"products/term-life/_slug":{"zh-CN":false},"products/term-life/compare":{"zh-CN":false},"products/term-life/index":{"zh-CN":false},"products/travel/_slug":{"zh-CN":false},"products/travel/compare":{"zh-CN":false},"products/travel/index":{"zh-CN":false},"products/whole-life-critical-illness/_slug":{"zh-CN":false},"products/whole-life-critical-illness/compare":{"zh-CN":false},"products/whole-life-critical-illness/index":{"zh-CN":false},"products/whole-life-protection/_slug":{"zh-CN":false},"products/whole-life-protection/compare":{"zh-CN":false},"products/whole-life-protection/index":{"zh-CN":false},"hong-kong-insurance/index":{"en":false,"zh-HK":false},"my-favourite/index":{"zh-CN":false},"latest-promotion":{"zh-CN":false},"media":{"zh-CN":false},"user-center":{"zh-CN":false}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en","iso":"en-US","file":"en-US.js","name":"EN"},{"code":"zh-HK","iso":"zh-HK","file":"zh-HK.js","name":"中"},{"code":"zh-CN","iso":"zh-CN","file":"zh-CN.js","name":"简中"}],
  localeCodes: ["en","zh-HK","zh-CN"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: "-",
  5: "U",
  6: "S",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "l",
  17: "o",
  18: "c",
  19: "a",
  20: "l",
  21: "e",
  22: "s",
  23: "/",
  24: "e",
  25: "n",
  26: "-",
  27: "U",
  28: "S",
  29: ".",
  30: "j",
  31: "s",
  32: "\"",
  33: ",",
  34: "\"",
  35: "z",
  36: "h",
  37: "-",
  38: "H",
  39: "K",
  40: ".",
  41: "j",
  42: "s",
  43: "\"",
  44: ":",
  45: "\"",
  46: ".",
  47: ".",
  48: "/",
  49: "l",
  50: "o",
  51: "c",
  52: "a",
  53: "l",
  54: "e",
  55: "s",
  56: "/",
  57: "z",
  58: "h",
  59: "-",
  60: "H",
  61: "K",
  62: ".",
  63: "j",
  64: "s",
  65: "\"",
  66: ",",
  67: "\"",
  68: "z",
  69: "h",
  70: "-",
  71: "C",
  72: "N",
  73: ".",
  74: "j",
  75: "s",
  76: "\"",
  77: ":",
  78: "\"",
  79: ".",
  80: ".",
  81: "/",
  82: "l",
  83: "o",
  84: "c",
  85: "a",
  86: "l",
  87: "e",
  88: "s",
  89: "/",
  90: "z",
  91: "h",
  92: "-",
  93: "C",
  94: "N",
  95: ".",
  96: "j",
  97: "s",
  98: "\"",
  99: "}",
}

export const localeMessages = {
  'en-US.js': () => Promise.resolve(locale6010b66b),
  'zh-HK.js': () => Promise.resolve(localeb12da6aa),
  'zh-CN.js': () => Promise.resolve(localeb1b7d77a),
}
